(function () {
   var SAMPLE_PROP = "_sample_offer";
   var mutationInFlight = false;

   function toCents(value) {
      var n = Number(value || 0);
      return Number.isFinite(n) ? Math.round(n * 100) : 0;
   }

   function getAllowedSamples(nonSampleTotalCents, thresholds) {
      if (nonSampleTotalCents >= thresholds.t3) return 3;
      if (nonSampleTotalCents >= thresholds.t2) return 2;
      if (nonSampleTotalCents >= thresholds.t1) return 1;
      return 0;
   }

   function isSampleLine(item) {
      return Boolean(item && item.properties && item.properties[SAMPLE_PROP]);
   }

   async function fetchCart() {
      var res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) throw new Error("Cart fetch failed");
      return res.json();
   }

   async function postChangeByLine(line, quantity) {
      await fetch("/cart/change.js", {
         method: "POST",
         headers: { "Content-Type": "application/json" },
         credentials: "same-origin",
         body: JSON.stringify({ line: line, quantity: quantity }),
      });
   }

   async function postChangeByKey(key, quantity) {
      await fetch("/cart/change.js", {
         method: "POST",
         headers: { "Content-Type": "application/json" },
         credentials: "same-origin",
         body: JSON.stringify({ id: key, quantity: quantity }),
      });
   }

   async function postAdd(variantId) {
      await fetch("/cart/add.js", {
         method: "POST",
         headers: { "Content-Type": "application/json" },
         credentials: "same-origin",
         body: JSON.stringify({
            items: [
               {
                  id: variantId,
                  quantity: 1,
                  properties: {
                     _sample_offer: "1",
                  },
               },
            ],
         }),
      });
   }

   function getSectionsToRender() {
      var sections = [
         {
            id: "mini-cart",
            section: document.getElementById("mini-cart") ? document.getElementById("mini-cart").id : null,
            selector: ".shopify-section",
         },
         {
            id: "main-cart-items",
            section: document.getElementById("main-cart-items") ? document.getElementById("main-cart-items").dataset.id : null,
            selector: ".js-contents",
         },
         {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section",
         },
         {
            id: "mobile-cart-icon-bubble",
            section: "mobile-cart-icon-bubble",
            selector: ".shopify-section",
         },
         {
            id: "cart-live-region-text",
            section: "cart-live-region-text",
            selector: ".shopify-section",
         },
         {
            id: "main-cart-footer",
            section: document.getElementById("main-cart-footer") ? document.getElementById("main-cart-footer").dataset.id : null,
            selector: ".js-contents",
         },
      ];

      if (document.querySelector("#main-cart-footer .free-shipping")) {
         sections.push({
            id: "main-cart-footer",
            section: document.getElementById("main-cart-footer") ? document.getElementById("main-cart-footer").dataset.id : null,
            selector: ".free-shipping",
         });
      }

      return sections.filter(function (section) {
         return Boolean(section.section);
      });
   }

   function getSectionInnerHTML(html, selector) {
      var parsed = new DOMParser().parseFromString(html, "text/html");
      var node = parsed.querySelector(selector);
      return node ? node.innerHTML : "";
   }

   async function refreshCartUI() {
      var sectionsToRender = getSectionsToRender();
      if (sectionsToRender.length === 0) {
         return;
      }

      var sections = sectionsToRender.map(function (section) {
         return section.section;
      });

      var response = await fetch("/cart/update.js", {
         method: "POST",
         headers: { "Content-Type": "application/json" },
         credentials: "same-origin",
         body: JSON.stringify({
            updates: {},
            sections: sections,
            sections_url: window.location.pathname,
         }),
      });

      if (!response.ok) {
         throw new Error("Cart refresh failed");
      }

      var parsedState = await response.json();
      var parsedSections = parsedState && parsedState.sections ? parsedState.sections : {};

      sectionsToRender.forEach(function (section) {
         var element = document.getElementById(section.id);
         if (!element) return;

         var html = parsedSections[section.section];
         if (!html) return;

         var elementToReplace = element.querySelector(section.selector) || element;
         if (!elementToReplace) return;

         elementToReplace.innerHTML = getSectionInnerHTML(html, section.selector);
      });

      document.dispatchEvent(
         new CustomEvent("cart:updated", {
            detail: {
               cart: parsedState,
            },
         }),
      );
   }

   async function enforceSampleLimit(container) {
      if (mutationInFlight) return;

      var exchangeRate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1') || 1;
      var t1 = toCents(parseFloat(container.dataset.threshold1 || 0) * exchangeRate);
      var t2 = toCents(parseFloat(container.dataset.threshold2 || 0) * exchangeRate);
      var t3 = toCents(parseFloat(container.dataset.threshold3 || 0) * exchangeRate);

      var cart = await fetchCart();
      var sampleLines = [];
      var nonSampleTotal = 0;
      var currentSampleCount = 0;

      cart.items.forEach(function (item, idx) {
         if (isSampleLine(item)) {
            sampleLines.push({
               line: idx + 1,
               key: item.key,
               quantity: item.quantity,
            });
            currentSampleCount += item.quantity;
         } else {
            nonSampleTotal += item.final_line_price;
         }
      });

      var allowed = getAllowedSamples(nonSampleTotal, { t1: t1, t2: t2, t3: t3 });
      var excess = currentSampleCount - allowed;

      // Sync container visibility and slot button count with the exchange-rate-corrected allowed value.
      // Liquid renders these based on the raw EUR threshold (wrong for non-EUR currencies), so JS corrects it.
      if (allowed === 0) {
         container.classList.add('cart-samples--hidden');
      } else {
         container.classList.remove('cart-samples--hidden');
      }
      var expectedSlots = excess > 0 ? 0 : Math.max(0, allowed - currentSampleCount);
      var slotBtns = Array.from(container.querySelectorAll('.cart-samples__slot'));
      while (slotBtns.length > expectedSlots) {
         var slotToRemove = slotBtns.pop();
         if (slotToRemove) slotToRemove.remove();
      }

      if (allowed > 0) {
         var countLabels = [];
         try { countLabels = JSON.parse(container.dataset.countLabels || '[]'); } catch (e) {}
         var label = countLabels[allowed - 1];
         if (label) {
            container.querySelectorAll('.cart-samples__subtitle').forEach(function (el) {
               el.textContent = label;
            });
         }
      }

      if (allowed === 0 && currentSampleCount > 0) {
         mutationInFlight = true;
         try {
            for (var i = sampleLines.length - 1; i >= 0; i--) {
               await postChangeByKey(sampleLines[i].key, 0);
            }
            await refreshCartUI();
         } finally {
            mutationInFlight = false;
         }
         return;
      }

      if (excess > 0) {
         mutationInFlight = true;
         sampleLines.sort(function (a, b) {
            return a.line - b.line;
         });
         try {
            var toRemove = excess;
            for (var j = 0; j < sampleLines.length && toRemove > 0; j++) {
               var line = sampleLines[j];
               if (line.quantity <= toRemove) {
                  await postChangeByKey(line.key, 0);
                  toRemove -= line.quantity;
               } else {
                  await postChangeByKey(line.key, line.quantity - toRemove);
                  toRemove = 0;
               }
            }
            await refreshCartUI();
         } finally {
            mutationInFlight = false;
         }
      }
   }

   function bindPicker(container) {
      var openButtons = container.querySelectorAll("[data-cart-samples-open]");
      var closeButtons = container.querySelectorAll("[data-cart-samples-close]");
      var overlay = container.querySelector("[data-cart-samples-overlay]");

      openButtons.forEach(function (btn) {
         btn.addEventListener("click", function () {
            if (!overlay) return;
            overlay.removeAttribute("hidden");
            document.body.classList.add("cart-samples-picker-open");
         });
      });

      closeButtons.forEach(function (btn) {
         btn.addEventListener("click", function () {
            if (!overlay) return;
            overlay.setAttribute("hidden", "hidden");
            document.body.classList.remove("cart-samples-picker-open");
         });
      });

      if (overlay) {
         overlay.addEventListener("click", function (e) {
            if (e.target === overlay) {
               overlay.setAttribute("hidden", "hidden");
               document.body.classList.remove("cart-samples-picker-open");
            }
         });
      }

      container.querySelectorAll("[data-cart-samples-add]").forEach(function (btn) {
         btn.addEventListener("click", async function () {
            var variantId = Number(btn.getAttribute("data-variant-id"));
            if (!variantId) return;

            if (mutationInFlight) return;
            btn.disabled = true;
            mutationInFlight = true;
            try {
               await postAdd(variantId);
               await enforceSampleLimit(container);
               await refreshCartUI();
            } catch (err) {
               btn.disabled = false;
            } finally {
               mutationInFlight = false;
            }
         });
      });
   }

   function initContainer(container) {
      if (!container || container.dataset.cartSamplesInit === "1") return;
      container.dataset.cartSamplesInit = "1";

      bindPicker(container);
      enforceSampleLimit(container).catch(function () {
         return null;
      });
   }

   function initAll() {
      document.querySelectorAll("[data-cart-samples]").forEach(initContainer);
   }

   document.addEventListener("DOMContentLoaded", initAll);

   var observer = new MutationObserver(function () {
      initAll();
   });

   observer.observe(document.documentElement, { childList: true, subtree: true });
})();
